import React, { useState, useEffect, useContext } from "react";
import Loader from "../../components/Spinner";
import "react-toastify/dist/ReactToastify.css";
import useTranslator from "../../hooks/useTranslator";
import LandLordContext from "../../context/landlord/LandLordContext";
import { getIncomeForEffortRate, haveValue } from "../../helper/common";
import GeneratedReportComponent from "../../components/Landlord/GeneratedReportComponent";
import AuthContext from "../../context/auth/AuthContext";
import axiosInstance from "../../services/authWrapper";
import { toast } from "react-toastify";

const GeneratedReport = ({
  // id,
  user,
  llCreated,
  type,
  definedRent,
  bestSkor,
  setBestSkor,
  setUserIncomes,
  setUserMaxRent,
  ids,
  index,
  fetchUserById,
  sharedProfileInfo,
}) => {
  const { _t } = useTranslator();

  const landLordContext = useContext(LandLordContext);
  const { properties, fetchingCreatedTenant } = landLordContext;
  const {
    checkIeDetails,
    user: originalUser,
    loadUser,
  } = useContext(AuthContext);

  // const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(false);
  const [rentPercentage, setRentPercentage] = useState(1);
  const [fullInfo, setFullInfo] = useState({});

  useEffect(() => {
    let usertype = localStorage.getItem("usertype");
    console.log("In Report ", usertype);
    loadUser(usertype);
  }, []);

  useEffect(() => {
    if (haveValue(user)) {
      const user_data = haveValue(user?.tenantid) ? user?.tenantid : user;
      const user_income = getIncomeForEffortRate(user_data, originalUser, _t);
      setUserIncomes((prev) => ({ ...prev, [user?._id]: user_income?.amount }));
    }
  }, [user]);

  if (loading) return <Loader />;

  return (
    <>
      {haveValue(user) && (
        <>
          <div className="tab-content" id="pills-tabContent">
            <div
              className="tab-pane fade show active"
              id="pills-profile"
              role="tabpanel"
              aria-labelledby="pills-profile-tab"
            >
              <div className="edit-profile">
                <div
                  className="tab-pane fade show active"
                  id="pills-home"
                  role="tabpanel"
                  aria-labelledby="pills-home-tab"
                >
                  <div className="edit-profile">
                    <GeneratedReportComponent
                      fullinfo={fullInfo}
                      rent_from_income={null}
                      scoreProfile={
                        haveValue(user?.tenantid) ? user?.tenantid : user
                      }
                      defaultPropertyLink={[]}
                      propList={[]}
                      rentPercentage={rentPercentage}
                      setRentPercentage={setRentPercentage}
                      llCreated={llCreated}
                      originalUser={originalUser}
                      setBestSkor={setBestSkor}
                      bestSkor={bestSkor}
                      setUserMaxRent={setUserMaxRent}
                      ids={ids}
                      index={index}
                      fetchUserById={fetchUserById}
                      sharedProfileInfo={sharedProfileInfo}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default GeneratedReport;
